import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { cargarCatalogosGenericoAsync  } from '../../funciones_globales/catalogos';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';


class FormCaja11  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,
            cliente_sel: null,
            tipoPeriodo: null,
        };
        
        this.limpiar = this.limpiar.bind(this);        
        this.generarReporte = this.generarReporte.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    getOptions_Clientes(input, callback){
        if (input.toString().length >= 3 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;
          cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }




    componentDidMount(){
        Promise.all([
            this.props.generar_LogAuditoriaIngresoForm('0511')
         ])
        .then(() => {
            let fechaHasta = moment(this.props.fechaProceso, "DD/MM/YYYY");
            let fechaDesde = fechaHasta.subtract(31, 'days');
            this.setState({fechaDesde: fechaDesde, fechaHasta: moment(this.props.fechaProceso, "DD/MM/YYYY"), tipoPeriodo:"E"});
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0511');
    } 

    generarReporte(){        
        try {

            let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
            }

            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }
            
            let urlReportWithParams =`&rpt=141&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;

            if(this.state.cliente_sel!==null){
                urlReportWithParams += '&param3='+this.state.cliente_sel.value
            }
            urlReportWithParams += '&param4='+this.state.tipoPeriodo


            visualizarReporteEnPdf(urlReportWithParams);
        } catch (error) {
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){        
        let fechaHasta = moment(this.props.fechaProceso, "DD/MM/YYYY");
        let fechaDesde = fechaHasta.subtract(31, 'days');
        this.setState({ fechaDesde: fechaDesde,
                        fechaHasta: moment(this.props.fechaProceso, "DD/MM/YYYY") ,
                        cliente_sel: null                      
                    });
    }


    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }



    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Reporte de Retenciones de Clientes</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={25}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo Seleccion:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-10'>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipoPeriodo' value='E' checked={this.state.tipoPeriodo==='E'} onChange={this.handleInputChange} />
                                Por Fecha Emision
                            </LabelForm>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipoPeriodo' value='C' checked={this.state.tipoPeriodo==='C'} onChange={this.handleInputChange} />
                                Por Fecha Contable
                            </LabelForm>
                        </ContainerCol>
                    </Row>


                    <Row>
                        <ContainerCol className='col-md-3' margen_arriba={10}>
                            <LabelForm>Fecha Desde:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-3' margen_arriba={10}>
                            <LabelForm>Fecha Hasta:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>
                        </ContainerCol>                                             
                    </Row>               
                    <Row>               
                    <ContainerCol className='col-md-6'>
                        <LabelForm>Cliente:</LabelForm>
                            <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{this.setState({cliente_sel: value})}}/>
                        </ContainerCol>
                    </Row>               
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={10}>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.generarReporte}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario
        }
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCaja11);